<template>
    <div class="p-4 pt-14 space-y-6">
        <!-- Welcome Card -->
        <div
            class="p-6 flex flex-col lg:flex-col items-start gap-6 bg-gradient-to-br from-primary/5 to-purple-100 dark:from-neutral-700/50 dark:to-neutral-800/50 rounded-xl border border-gray-200 dark:border-neutral-700 shadow-lg">
            <!-- Content -->
            <div class="flex-1 text-center sm:text-left">
                <h2 class="text-2xl font-bold text-gray-800 dark:text-white">
                    {{ $t('Welcome to') }} {{client.name}}!
                </h2>
                <p class="mt-2 text-gray-600 dark:text-neutral-300 text-sm sm:text-base">
                    {{$t("We're building a fair and local platform where travelers and hosts can connect")}}.<br/>
                    {{$t("Every contribution adds value: together, we can showcase hidden gems, celebrate local culture, and create authentic experiences for everyone to enjoy")}}.
                </p>
            </div>

            <!-- CTA Button -->
            <div class="flex flex-col w-full sm:flex-row gap-2 mt-4 sm:mt-0" v-if="accessTypes.includes('App\\Models\\Event') || accessTypes.includes('App\\Models\\Location')">
                
                <router-link :to="{ name: 'events' }" v-if="accessTypes.includes('App\\Models\\Event')" class="inline-flex text-center items-center justify-center px-4 py-4 md:py-2 text-sm font-medium text-white bg-gradient shadow-xl rounded-xl shadow hover:bg-primary/90 transition">
                    {{ $t('Promote your event') }}
                </router-link>
                <router-link :to="{ name: 'locations' }"  v-if="accessTypes.includes('App\\Models\\Location')" class="inline-flex text-center items-center justify-center px-4 py-4 md:py-2 text-sm font-medium text-white bg-gradient shadow-xl rounded-xl shadow hover:bg-primary/90 transition">
                    {{ $t('Promote your location') }}
                </router-link>
            </div>
            <div v-else class="flex-1 text-center sm:text-left">
                
            </div>
        </div>

        <!-- Feature Highlights (optional) -->
        <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div
                class="p-4 bg-white dark:bg-neutral-800 rounded-lg border border-gray-200 dark:border-neutral-700 shadow-sm">
                <h3 class="font-semibold text-gray-800 dark:text-white">{{$t('Support Local Hosts')}}</h3>
                <p class="mt-1 text-sm text-gray-600 dark:text-neutral-300">
                    {{$t('Promote and discover authentic experiences while supporting local communities')}}.
                </p>
            </div>
            <div
                class="p-4 bg-white dark:bg-neutral-800 rounded-lg border border-gray-200 dark:border-neutral-700 shadow-sm">
                <h3 class="font-semibold text-gray-800 dark:text-white">{{$t('Curated Experiences')}}</h3>
                <p class="mt-1 text-sm text-gray-600 dark:text-neutral-300">
                    {{$t('Discover hidden gems, cultural experiences, and unforgettable adventures')}}.
                </p>
            </div>
            <div
                class="p-4 bg-white dark:bg-neutral-800 rounded-lg border border-gray-200 dark:border-neutral-700 shadow-sm">
                <h3 class="font-semibold text-gray-800 dark:text-white">{{$t('Explore Together')}}</h3>
                <p class="mt-1 text-sm text-gray-600 dark:text-neutral-300">
                    {{$t('By sharing and exploring local experiences, we create a richer and more meaningful platform for everyone')}}.
                </p>
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    name: "main",
    props: {
        client: {
            type: Array,
            default: () => [],
        },
        accessTypes: {
            type: Array,
            default: () => [],
        },
    },
};
</script>
  